<template>
  <transition>
    <div v-if="propPedidoCrc">
      <sub-header-grey class="pt-3 pb-1 pl-3 mt-3">
        <label class="label">Pedido CRC</label>
      </sub-header-grey>
      <div class="row col-12 mb-4 mt-4 align-content-center">
        <div class="col-3 pr-0 mr-3">
          <CustomInput v-if="propPedidoPendente || propPedidoP13 && Object.keys(propPedidoPendente).length > 0"
                       name="num_pedido_crc"
                       label="Pedido CRC"
                       :initial-value="(propPedidoPendente && propPedidoPendente.pedido_certidao_id) || (propPedidoP13 && propPedidoP13.numero_pedido) || (propOrdemServico && propOrdemServico.num_pedido_crc)"
                       validate-type="pedidoCRC"
                       type="text"
                       :form-erros="formErros"
                       :disabled="!!propOrdemServico.ordem_servico_id"
                       @setError="setError"
                       @blur="setValueInput" />

          <CustomInput v-else
                       name="num_pedido_crc"
                       label="Pedido CRC"
                       :initial-value="propOrdemServico.num_pedido_crc"
                       validate-type="pedidoCRC"
                       type="text"
                       :required="propPedidoCrc"
                       :form-erros="formErros"
                       :disabled="!!propOrdemServico.ordem_servico_id"
                       :mask-type="!propOrdemServico.ordem_servico_id ? 'pedidoCRC' : null"
                       @setError="setError"
                       @blur="setValueInput" />
        </div>
        <div v-if="!propOrdemServico.registro_id"
             class="col-6 pr-0 mr-3">
          <label class="label">O pedido é referente a um cartório do Estado de São Paulo?</label>
          <div class="mt-1">
            <div class="form-check form-check-inline">
              <input id="inlineRadio1"
                     class="form-check-input"
                     type="radio"
                     name="inlineRadioOptions"
                     :value="pedidoOutrosEstados"
                     :checked="propOrdemServico.uf_cartorio === 'OUTRO'"
                     :disabled="!!propOrdemServico.ordem_servico_id"
                     @click="updateUF('OUTRO')">
              <label class="form-check-label"
                     for="inlineRadio1">Não</label>
            </div>
            <div class="form-check form-check-inline">
              <input id="inlineRadio2"
                     class="form-check-input"
                     type="radio"
                     name="inlineRadioOptions"
                     :value="pedidoSp"
                     :checked="propOrdemServico.uf_cartorio === 'SP'"
                     :disabled="!!propOrdemServico.ordem_servico_id"
                     @click="updateUF('SP')">
              <label class="form-check-label"
                     for="inlineRadio2">Sim</label>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex mt-5 mb-5">
        <transition>
          <div v-show="propOrdemServico.uf_cartorio && !propOrdemServico.registro_id"
               class="col-4 pr-0 mr-3">
            <CustomInput
              name="num_matricula_registro"
              label="Número da Matricula do Registro"
              validate-type="matricula"
              type="text"
              :initial-value="propOrdemServico.num_matricula_registro"
              :required="propOrdemServico.uf_cartorio && !propOrdemServico.registro_id"
              :form-erros="formErros"
              :disabled="!!propOrdemServico.ordem_servico_id"
              mask-type="matricula"
              @setError="setError"
              @blur="setValueInput" />
          </div>
        </transition>
        <transition mode="out-in">
          <div v-if="propOrdemServico.uf_cartorio === 'OUTRO' && !propOrdemServico.registro_id"
               key="valorCusta"
               class="col-4 pr-0 mr-3">
            <CustomInput
              name="valor_da_custa"
              label="Valor da custa do Cartório Emissor"

              validate-type="dinheiro"
              type="text"
              :initial-value="propOrdemServico.valor_da_custa"
              :required="propOrdemServico.uf_cartorio === 'OUTRO' && !propOrdemServico.registro_id"
              :form-erros="formErros"
              :disabled="!!propOrdemServico.ordem_servico_id"
              :prop-money="true"
              @setError="setError"
              @blur="setValueInput" />
          </div>
          <div v-else-if="propOrdemServico.uf_cartorio === 'SP'"
               key="numeroSelo"
               class="col-5 pr-0 mr-3">
            <CustomInput
              name="num_selo"
              label="Número do Selo Cartório Emissor" 
              
              type="text"
              :initial-value="propOrdemServico.num_selo"
              :required="propOrdemServico.uf_cartorio === 'SP' && !propOrdemServico.registro_id"
              :form-erros="formErros"
              :disabled="!!propOrdemServico.ordem_servico_id"
              description="O selo informado não deve ter sido vinculado anteriormente"
              @setError="setError"
              @blur="setValueInput" />
          </div>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
  //components
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"
  import CustomInput from "@/components/CustomInputs/CustomInput.vue"

  //libs
  import { VMoney } from 'v-money'
  import { mount } from "@vue/test-utils"

  export default {
    name: "PedidoCRC",
    components: {
      SubHeaderGrey,
      CustomInput
    },
    directives: {
      money: VMoney
    },
    props: {
      propPedidoCrc: {
        type: Boolean,
        default: false,
      },
      propOrdemServico: {
        type: Object,
        default: () => {}
      },
      propPedidoPendente: {
        type: Object,
        default: () => {}
      },
      propPedidoP13:  {
        type: Object,
        default: () => {}
      },
    },
    data () {
      return {
        pedidoSp: false,
        pedidoOutrosEstados: false,
        form: {
          num_pedido_crc: null,
          num_matricula_registro: null,
          num_selo: null,
          uf_cartorio: null,
          valor_da_custa: null
        },
        formErros: [],
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
        pedidoPendente: {}
      }
    },
    watch: {
      pedidoSp () {
        if (this.pedidoSp === true) {
          this.propOrdemServico.uf_cartorio = 'SP'
          this.pedidoOutrosEstados = false
        } else this.resetFotm()
      },
      pedidoOutrosEstados () {
        if (this.pedidoOutrosEstados === true) {
          this.propOrdemServico.uf_cartorio = 'OUTRO'
          this.pedidoSp = false   
        }
      },
      propOrdemServico () {
        if (this.propOrdemServico.uf_cartorio == 'SP') {
          this.pedidoSp = true          
        }
        if (this.propOrdemServico.uf_cartorio == 'OUTRO') {
          this.pedidoOutrosEstados = true          
        }
      },

      propPedidoCrc () {
        let pedidoInicial = null
        if (this.propPedidoPendente && !!this.propPedidoPendente.pedido_certidao_id) {
          pedidoInicial = this.propPedidoPendente.pedido_certidao_id
        }

        if (pedidoInicial) {
          this.$emit('updateCRCData', 'num_pedido_crc', pedidoInicial)
        }
      },

    propPedidoP13(newVal) {
        if (newVal && newVal.numero_pedido) {
          this.form.num_pedido_crc = newVal.numero_pedido
          this.$emit('updateCRCData', 'num_pedido_crc', newVal.numero_pedido)
        }
   },
    },
    methods: {
      setValueInput (name, value) { 
        this.$emit('updateCRCData', name, value)
      },
      updateUF (value) {
        this.$emit('updateCRCData', 'num_selo', null)
        this.$emit('updateCRCData', 'valor_da_custa', null)
        this.$emit('updateCRCData', 'uf_cartorio', value)
      },
      resetFotm () {
        this.form = {
          num_pedido_crc: null,
          num_matricula_registro: null,
          num_selo: null,
          uf_cartorio: null,
          valor_da_custa: null
        }

        this.$emit('updateCRCData', this.form)
      },
      setError (newArray) {
        this.formErros = newArray        
      },
      changePedidoSp () {
        this.pedidoSp = true
        this.pedidoOutrosEstados = false
      },
      changePedidoOutrosEstados () {
        this.pedidoOutrosEstados = true
        this.pedidoSp = false
      },
    }
  }  
</script>

<style scoped>
  .v-enter-active {
    transition: opacity 1s;
  }
  .v-enter {
    opacity: 0;
  }
  .v-leave-active {
    transition: opacity .5s;;
  }
  .v-leave-to {
    opacity: 0;
  }
</style>